import React from 'react';
import { Nav } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { useAppConfig } from '@landr/mfe';

export const FooterNavigation: React.FC = () => {
    const { links } = useAppConfig();
    const supportLink = links.supportLink.originUrl;

    return (
        <Nav justifyContent="center" gap={{ base: 'sm', lg: 'xl' }}>
            <Nav.Item>
                <Nav.Link
                    href="https://www.landr.com/samples"
                    target="_blank"
                    p="none"
                >
                    <Trans>About</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://blog.landr.com/"
                    target="_blank"
                    p="none"
                >
                    <Trans>Blog</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as="a" href={supportLink} target="_blank" p="none">
                    <Trans>Help</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://landr.com/careers"
                    target="_blank"
                    p="none"
                >
                    <Trans>Careers</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://landr.com/en/pricing-terms"
                    target="_blank"
                    p="none"
                >
                    <Trans>Legal</Trans>
                </Nav.Link>
            </Nav.Item>
        </Nav>
    );
};
